import apiClient from "../../../utils/apiclient";

// ✅ Accept token as argument
export const getSfaData = async (
  reqBody: Record<string, any>,
  token: string
) => {
  try {
    const res = await apiClient.post(
      "/import-csv/getAll",
      {
        ...reqBody,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ token from UI
        },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Error fetching SFA data:", err);
    throw err;
  }
};


export const getActivityLogs = async (
  reqBody: Record<string, any>,
  token: string
) => {
  try {
    const res = await apiClient.post(
      "/import-csv/get-activity-logs",
      {
        ...reqBody,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Error fetching activity logs:", err);
    throw err;
  }
};

// api.ts
export const uploadTargetSFA = async (file: File, token: string) => {
  const formData = new FormData();
  formData.append("file", file);

  return await apiClient.post("/import-csv/import-target-sfa", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`, // ✅ include token
    },
  });
};


export const uploadRewardsSFA = async (file: File, token: string) => {
  const formData = new FormData();
  formData.append("file", file);

  return await apiClient.post("/import-csv/import-Rewards-sfa", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const uploadActualSFA = async (file: File, token: string) => {
  const formData = new FormData();
  formData.append("file", file);

  return await apiClient.post("/import-csv/import-actual-sfa", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`, // ✅ include token
    },
  });
};

export const exportSFAReport = async (reqBody: Record<string, any>,token:string) => {

  return await apiClient.post(
    "/import-csv/export-sfa",
    {
      ...reqBody,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/octet-stream",
      },
      responseType: "blob", // important for Excel download
    }
  );
};


export const viewretailersv2=async(reqBody:{
   locations: string[];
   outlet_type:string[]
      search: string;
      page: string,
      limit: string,
      lastLogin:string
     
  },token:string)=>{
     return await apiClient.post('/admin/task/view_retailers_v1',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
     })
  }